import React, { useContext, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import "../../styles/filesComponent.pc.css";
import { Context } from "../../../index";
import Search from "../../UiLib/Search/Search";
import BtnAdd from "../../buttons/btnAdd.component/BtnAdd";
import "./Files.css";
import BtnCancel from "../../buttons/CancelButton/CancelButton";
import BtnDelete from "../../buttons/btnDelete.component/BtnDelete";
import BtnDownload from "../../buttons/btnDownload.component/BtnDownload";
import { ProjectContext } from "../../../pages/Project/Project";
import ConfirmationWindow from "../../Shared/ConfirmationWindow/ConfirmationWindow";
import Checkbox from "../../Shared/Checkbox/Checkbox";
import CloseBlockWindow from "../../../assets/arrowCloseWindow.svg";
import OpenBlock from "../../../assets/openBlock.svg";
import { AppContext } from "../../../App";
import { IFunctionPermissions } from "../../../common/api_interfaces/role/IFunctionPermissions";
import { hasPermission } from "../../../helpers/hasPermisson";
import axios from "axios";
import { IFilesDisplay } from "../../../common/api_interfaces/files/IFilesDisplay";
import { IFileFilters } from "../../../common/api_interfaces/files/IFileFilters";

interface IFilesProps {
    files: IFilesDisplay | undefined;
    updateFilters: (filters: IFileFilters) => void;
    userAccess: IFunctionPermissions[];
    // filterOptions: IFileFilterOptions | undefined;
}

const Files: React.FC<IFilesProps> = ({
    files,
    // filterOptions,
    updateFilters,
    userAccess
}) => {
    const { store } = useContext(Context);
    const isCollapsed = store.leftMenuCollapsed;
    const { loadFiles } = useContext(ProjectContext);
    const { showToast } = useContext(AppContext);
    const { id } = useParams();
    const [deletFilesIds, setDeletFilesIds] = useState<number[]>([]);
    const selectedFileId = useRef(null);
    const [searchValue, setSearchValue] = useState("");
    const [openConfirmWindow, setOpenConfirmWindow] = useState(false);
    const [openOnFullWindow, setOpenOnFullWindow] = useState(false);
    const [viewFiles, setViewFiles] = useState(false);
    const [addFile, setAddFile] = useState(false);
    const [delFile, setDelFile] = useState(false);

    useEffect(() => {
        setViewFiles(hasPermission(userAccess, "ProjectFileAction", "view"));
        setAddFile(hasPermission(userAccess, "ProjectFileAction", "create"));
        setDelFile(hasPermission(userAccess, "ProjectFileAction", "delete"));
    }, [userAccess]);

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const widget = containerRef.current;

        if (openOnFullWindow && widget) {
            widget?.scrollIntoView({ behavior: "auto", block: "center" });
        }
    }, [openOnFullWindow]);

    useEffect(() => {
        const keyDownHandler = (event: any) => {
            if (event.key === "Escape") {
                event.preventDefault();
                onCancelClick();
            }
        };

        document.addEventListener("keydown", keyDownHandler);
        // Clean up event listener
        return () => {
            document.removeEventListener("keydown", keyDownHandler);
        };
    }, [userAccess]);

    const filters = useRef<IFileFilters>({
        projectId: Number(id),
        fileType: [],
        name: "",
    });

    const handleCancelClick = () => {
        clearSelectedFiles();
    };

    const handleAddClick = () => { };

    const clearSelectedFiles = () => {
        const checkboxes = document.querySelectorAll('input[type="checkbox"]') as unknown as any[];
        for (let item of checkboxes) {
            if (item.getAttribute("checkboxgroup") === "file-selection") {
                item.checked = false;
            }
        }
    };

    const handleSubmit = (event: any) => {
        event.preventDefault();
    };

    const handleFilterClick = (event: any) => { };

    const handleDeleteClick = (event: any) => { };

    const handleFileSelection = (fileId: number, event: any) => {
        let ids = deletFilesIds;
        if (event.target.checked) {
            ids.push(fileId);
        } else {
            let index = ids.findIndex((i) => i === fileId);
            if (index !== -1) {
                ids.splice(index, 1);
            }
        }
        setDeletFilesIds([...ids]);
    };

    const handleDownloadClick = (event: any) => {
        event.stopPropagation();
    };

    function onSearchSubmit(value: string) {
        let newFilters = { ...filters.current };
        newFilters.name = value;
        filters.current = newFilters;
        updateFilters(filters.current);
    }

    function onFilterClick() { }

    function onCancelClick() {
        setSearchValue("");
        (async () => {
            await loadFiles({
                projectId: Number(id),
                name: "",
                fileType: [],
            });
        })();
    }

    async function onDelete() {
        if (!deletFilesIds?.length) return;

        try {
            await store.fileService.deleteFile(deletFilesIds);
            await loadFiles({
                projectId: Number(id),
                name: "",
                fileType: [],
            });
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                showToast(error.response?.data?.message, error.response?.data?.details);
            }
        }

        setDeletFilesIds([]);
    }

    function onAddClick(e: any) {
        (async () => {
            try {
                await store.fileService.addFileToProject(e.target.files[0], Number(id), 1);
                await loadFiles({
                    projectId: Number(id),
                    name: "",
                    fileType: [],
                });
            } catch (error: any) {
                const isFileTooLarge = error.response?.status === 413 || error.response?.data?.includes?.("413 Request Entity Too Large");
                if (isFileTooLarge) {
                    showToast("Ошибка загрузки: Файл слишком большой");
                } else if (error.response?.data?.message) {
                    showToast(error.response.data.message, error.response.data.details);
                } else {
                    showToast("Ошибка загрузки: произошла неизвестная ошибка");
                }
            }
        })();
    }
    async function onDownloadClick(itemId: number, type: string, name: string) {
        try {
            const response = await store.fileService.downloadFile(itemId.toString());
            const blob = response.data;
            const link = document.createElement("a");
            link.download = `${name}${type}`;
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                showToast(error.response?.data?.message);
            }
        }
    }

    const onConfirm = () => {
        onDelete();
        setOpenConfirmWindow(false);
    };
    const onCancel = () => {
        setOpenConfirmWindow(false);
    };

    const openConfWindow = () => {
        if (delFile) {
            setOpenConfirmWindow(true);
        } else {
            showToast("У вас нет прав для удаления файла!");
        }
    };
    return (
        <div
            id="project-files-widget-component"
            className={`project-files-widget-component ${openOnFullWindow ? "widget_wrapper--full__window" : "widget_wrapper"
                }`}
        >
            <div className={openOnFullWindow ? "widget_wrapper-full__window--block" : "widget_wrapper_block"}>
                {openConfirmWindow &&
                    (deletFilesIds?.length === 1 ? (
                        <ConfirmationWindow
                            headerText="Удаление файла"
                            bodyText="Вы уверены, что хотите удалить файл?"
                            confirmText="Да"
                            cancelText="Нет"
                            onConfirm={onConfirm}
                            onCancel={onCancel}
                        />
                    ) : (
                        <ConfirmationWindow
                            headerText="Удаление файлов"
                            bodyText="Вы уверены, что хотите удалить файлы?"
                            confirmText="Да"
                            cancelText="Нет"
                            onConfirm={onConfirm}
                            onCancel={onCancel}
                        />
                    ))}
                <div className={"widgets_header--container"}>
                    {openOnFullWindow ? (
                        <div onClick={() => setOpenOnFullWindow(false)} className="widgets_header--open__block">
                            <img src={CloseBlockWindow} />
                        </div>
                    ) : (
                        <div
                            onClick={() => setOpenOnFullWindow(true)}
                            className="widgets_header--open__block"
                            ref={containerRef}
                        >
                            <img src={OpenBlock} />
                        </div>
                    )}
                </div>
                <div className="widgets_header">
                    <div className="widgets_header--name__files">
                        <h2 className="widget-card-header-style">Файлы</h2>
                    </div>
                    <div className="widjets_header_rigth">
                        <Search value={searchValue} onSubmitFunc={onSearchSubmit} changeSearchValue={setSearchValue} />
                        {searchValue && <BtnCancel onClickFunc={onCancelClick} />}
                        {deletFilesIds?.length !== 0 && <BtnDelete onClickFunc={openConfWindow} permission={delFile} />}
                        <BtnAdd type={"file"} onClickFunc={onAddClick} permission={addFile} />
                    </div>
                </div>
                <div id="files-widget-items-container" className="files-widget-container">
                    {viewFiles &&
                        files?.files?.map((item, index) => (
                            <div key={item.id} className="files-widget-file-card">
                                <Checkbox id={item.id} handleSelection={handleFileSelection} />
                                <div
                                    title={`${item.name}${item.type}`}
                                    className="ellipses files-widget-file-name-text"
                                >
                                    {/* <div className='files-widget-file-name-text'>{item.name}</div>
                                <div className='files-widget-file-type-text'>{item.type}</div> */}
                                    {`${item.name}${item.type}`}
                                    {/* <p className='ellipses'>{item.type}</p> */}
                                </div>

                                <div style={{ display: "flex", verticalAlign: "middle", marginLeft: "auto" }}>
                                    <BtnDownload
                                        onClickFunc={() => onDownloadClick}
                                        itemId={item.id}
                                        url={item.url}
                                        type={item.type}
                                        name={item.name}
                                        permission={viewFiles}
                                    />
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default observer(Files);
